export type RangeOutputType = [Date?, Date?];

export interface RangeType {
  from: undefined | Date;
  to: undefined | Date;
}

export enum DatePickerMode {
  SINGLE = 'single',
  RANGE = 'range',
}

export interface CustomSelectorProps {
  handleCustomDateChange: (values: RangeType | Date) => void;
  mode: DatePickerMode;
  setCustomPeriodSelected: (data: string) => void;
}

export interface NavbarProps {
  onPreviousClick?: () => void;
  onNextClick?: () => void;
  className?: string;
}

export interface YearMonthSelectorProps {
  date: Date;
  localeUtils: {
    getMonths: () => string[];
  };
  onChange: (handleYearMonthChange: Date) => void;
  // TODO: check only number[]
  years: number[];
}

export interface DateRangePickerProps {
  startDate: Date;
  endDate: Date;
  value?: string[];
  onApply?: (range: RangeOutputType) => void;
  onSingleApply?: (range: Date) => void;
  onReset?: () => void;
  twoPickers?: boolean;
  withoutCustomSelector?: boolean;
  mode?: DatePickerMode;
  disabledAfter?: Date;
  prevDatepickerVisible?: boolean;
  datepickerVisible?: boolean;
  filterPlace?: boolean;
  birthdayPicker?: boolean;
  title?: string;
  withTitle?: boolean;
  withResetClose?: boolean;
  setDatepickerVisible?: (data: boolean) => void;
  withTime?: boolean;
  withTimeSelector?: boolean;
  withTwoTimeSelector?: boolean;
}

export interface LoopScrollTypes {
  surroundingBackup?: number;
  className?: string;
  children: React.ReactNode;
  type: 'hour' | 'minute';
  currentTime: number;
}
